import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.AdditionalDocumentsStep.StepForm', {
    explanation:
        'Sometimes providing us with additional documents can help improve your experience. This step is optional.',
    whyDocuments: 'Why upload additional documents?',
    docTypeProofOfFunds: 'Proof of source of funds',
    docTypeOther: 'Other',
    requirements: 'JPG, PNG, PDF. Max 10 Mb',
});
